import { B2bBaseState } from "../app/reducers";

export const getHasSeenModalMap = (state: { rootReducer: B2bBaseState }) =>
  state?.rootReducer?.hasSeenModalMap;
